import { IconButton } from '@material-ui/core'
import MoreIcon from '@material-ui/icons/MoreVert'
import { Skeleton } from '@material-ui/lab'

import useStyles from './styles/BookingsListTableRow.styles'

export const BookingsListTableRowSkeleton = () => {
  const classes = useStyles()

  return (
    <div className={classes.tableRow}>
      <div>
        <Skeleton animation="wave" className={classes.skeleton} />
      </div>
      <div>
        <Skeleton animation="wave" className={classes.skeleton} />
      </div>
      <div>
        <Skeleton animation="wave" className={classes.skeleton} />
      </div>
      <div>
        <Skeleton animation="wave" className={classes.skeleton} />
      </div>
      <div>
        <Skeleton animation="wave" className={classes.skeleton} />
      </div>
      <div>
        <Skeleton animation="wave" className={classes.skeleton} />
      </div>
      <div>
        <Skeleton animation="wave" className={classes.skeleton} />
      </div>
      <div>
        <Skeleton animation="wave" className={classes.skeleton} />
      </div>
      <div>
        <Skeleton animation="wave" className={classes.skeleton} />
      </div>
      <div>
        <Skeleton animation="wave" className={classes.skeleton} />
      </div>
      <div>
        <IconButton>
          <MoreIcon />
        </IconButton>
      </div>
    </div>
  )
}
